var app = angular.module('directives.smsConfirm');
  app.directive('smsConfirm', [
      '$translate',
      'PortalApi',
      '$timeout',
      'Localization',
      function($translate, PortalApi, $timeout, Localization) {
          return {
            restrict: 'E',
            scope: {
              label: '@',
              value: '=',
              symbols: '=',
              action: '=',
              clear: '<',
              fnc: '<'
            },
            template: require('../templates/smsConfirm.html'),
            controller: [
              '$scope',
              '$translate',
              'PortalApi',
              function($scope, $translate, PortalApi) {
                $scope.resendSMS = false;
                $scope.smsField = true;
                // $scope.smsCode = '';
                $scope.inputMask = "99-99-99";
                $scope.min = 5;

                $scope.sendSMS = function() {
                    PortalApi.smsCheck($scope.value.card.id, $scope.value.type).then(function(result) {
                      if (result.status == 'ok') {
                          $scope.smsField = true;
                          $scope.notifySuccessMssg($scope.value.type, 'smsSend');
                          $timeout(function () {
                            $scope.resendSMS = true;
                          }, 360000);
                      }
                      else {
                        $scope.notifyErrorMssg();
                      }
                    });
                };
                $scope.codeSend = function(code) {
                    if ($scope.value.type == 'disable3DS') {
                      PortalApi.disable3DS($scope.value.card.id, code).then(function(result) {
                        if (result.status == 'ok') {
                          $scope.notifySuccessMssg($scope.value.type, 'processCard');
                          $scope.fnc($scope.value.card);
                        } else {
                          $scope.notifyErrorMssg();
                        }
                      }, function (reason) {
                        $scope.notifyErrorMssg();
                      })
                    };
                    if ($scope.value.type == 'unblockCard') {
                      PortalApi.unblockCard($scope.value.card.id, code).then(function(result) {
                        if (result.status == 'ok') {
                          $scope.notifySuccessMssg($scope.value.type, 'processCard');
                          $scope.fnc($scope.value.card);
                        } else {
                          $scope.notifyErrorMssg();
                        }
                      }, function (reason) {
                        $scope.notifyErrorMssg();
                      })
                    };                };
                $scope.notifySuccessMssg = function (type, action) {
                  var message = '';
                  if (action == 'smsSend') {
                    message = 'AUTH.SMS-TIP';
                  }
                  if (action == 'processCard') {
                    if (type == 'blockCard') {
                      message = 'PREPAID.SUCCESS.BLOCK';
                    } else if (type == 'unblockCard') {
                      message = 'PREPAID.SUCCESS.UNBLOCK';
                    } else if (type == 'enable3DS') {
                      message = 'PREPAID.SUCCESS.3DS_UNBLOCK';
                    } else if (type == 'disable3DS') {
                      message = 'PREPAID.SUCCESS.3DS_BLOCK';
                    }
                  }

                  Localization.notifyTemplate('success', message, 1, true);

                };
                $scope.notifyErrorMssg = function () {

                    Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 1, true);

                  if ($scope.label == 'block') {
                    $scope.clear();
                  }
                };
                $scope.init = function() {
                  $scope.resendSMS = false;
                  $scope.sendSMS();
                };
                $scope.init();
              }
            ]
          }
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/smsConfirm/directives/smsConfirm.js
 ** module id = 235
 ** module chunks = 1
 **/